import React from 'react';
import { BounceLoader } from 'react-spinners';

const Loader = () => {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh', // Full viewport height to center vertically
      }}
    >
      <BounceLoader color='#52bf92' />
    </div>
  );
};

export default Loader;
